import React from 'react';
import {View, StyleSheet, SafeAreaView, ScrollView} from 'react-native';
import {withForwardedNavigationParams} from 'react-navigation-props-mapper';
import BackSubheader from 'src/components/elements/BackSubheader';
import Localized from 'src/constants/AppStrings';
import {checkValue} from 'src/Util';
import Styles from '../../Styles';
import AVText from 'src/components/elements/AVText';

type BlackLineProps = {
  height: number;
};
function BlackLine(props: BlackLineProps) {
  return <View style={[styles.blackLine, {height: props.height}]} />;
}

function ViewNutrition(props) {
  return (
    <BackSubheader title={props.nutrition?.productName}>
      <ScrollView style={{flex: 1}}>
        <SafeAreaView style={styles.container}>
          <View
            style={{
              paddingHorizontal: Styles.Spacing.m2,
              paddingVertical: Styles.Spacing.m1,
            }}
          >
            <AVText
              style={styles.title}
              maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm7}
              accessible
              testID="qa_NutritionFact_txt"
              nativeID="qa_NutritionFact_txt"
            >
              {Localized.Labels.nutrition_facts}
            </AVText>
            <BlackLine height={10} />

            <View style={styles.calorieContainer}>
              <AVText
                style={styles.smallText}
                maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm7}
              >
                {Localized.Labels.amount_per_serving}
              </AVText>
              <BlackLine height={1} />

              <View style={[styles.fullInformationRow, {marginBottom: 2}]}>
                <AVText
                  style={[styles.calorieText]}
                  maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm7}
                >
                  {Localized.Labels.calories}
                </AVText>
                <AVText
                  style={[styles.calorieText]}
                  maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm7}
                >
                  {props.product?.calories}
                </AVText>
              </View>
              {checkValue(props.nutrition?.caloriesFromFat) && (
                <View>
                  <View
                    style={[
                      styles.fullInformationRow,
                      {justifyContent: 'flex-end'},
                    ]}
                  >
                    <AVText
                      style={[styles.amtPerServingValue]}
                      maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm7}
                    >
                      {Localized.Labels.calories_from_fat}
                    </AVText>
                    <AVText
                      style={[styles.amtPerServingValue]}
                      maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm7}
                    >
                      {props.nutrition?.caloriesFromFat} g
                    </AVText>
                  </View>
                </View>
              )}
              <BlackLine height={5} />
            </View>
            <View
              style={[
                styles.row,
                {justifyContent: 'flex-end', marginBottom: Styles.Spacing.m1},
              ]}
            >
              <AVText
                style={styles.amtPerServingText}
                maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm7}
              >
                % {Localized.Labels.daily_value} *
              </AVText>
            </View>

            {props.nutrition && Object.keys(props.nutrition).length > 0 && (
              <React.Fragment>
                <View style={styles.column}>
                  {checkValue(props.nutrition?.totalFat) && (
                    <React.Fragment>
                      <BlackLine height={1} />
                      <View
                        style={{
                          flexDirection: 'row',
                          justifyContent: 'space-between',
                          marginBottom: Styles.Spacing.m1,
                        }}
                      >
                        <View style={styles.column}>
                          <View style={styles.row}>
                            <AVText
                              style={styles.amtPerServingText}
                              maxFontSizeMultiplier={
                                Styles.FontSizeMultiplier.maxfm7
                              }
                            >
                              {Localized.Labels.total_fat}
                            </AVText>
                            <AVText
                              style={styles.amtPerServingValue}
                              maxFontSizeMultiplier={
                                Styles.FontSizeMultiplier.maxfm7
                              }
                            >
                              {props.nutrition?.totalFat} g
                            </AVText>
                          </View>
                        </View>
                        {checkValue(
                          props.nutrition?.percentDailyValues?.totalFat,
                        ) && (
                          <View style={styles.column}>
                            <AVText
                              style={styles.amtPerServingText}
                              maxFontSizeMultiplier={
                                Styles.FontSizeMultiplier.maxfm7
                              }
                            >
                              {props.nutrition?.percentDailyValues?.totalFat} %
                            </AVText>
                          </View>
                        )}
                      </View>
                    </React.Fragment>
                  )}

                  {checkValue(props.nutrition?.saturatedFat) && (
                    <React.Fragment>
                      <BlackLine height={1} />
                      <View
                        style={[
                          styles.fullInformationRow,
                          {
                            marginLeft: checkValue(props.nutrition?.totalFat)
                              ? Styles.Spacing.m4
                              : null,
                          },
                        ]}
                      >
                        <View style={styles.column}>
                          <View style={styles.row}>
                            <AVText
                              style={styles.amtPerServingValue}
                              maxFontSizeMultiplier={
                                Styles.FontSizeMultiplier.maxfm7
                              }
                            >
                              {Localized.Labels.saturated_fat}
                            </AVText>
                            <AVText
                              style={styles.amtPerServingValue}
                              maxFontSizeMultiplier={
                                Styles.FontSizeMultiplier.maxfm7
                              }
                            >
                              {props.nutrition?.saturatedFat} g
                            </AVText>
                          </View>
                        </View>
                        {checkValue(
                          props.nutrition?.percentDailyValues?.saturatedFat,
                        ) && (
                          <View style={styles.column}>
                            <AVText
                              style={styles.amtPerServingText}
                              maxFontSizeMultiplier={
                                Styles.FontSizeMultiplier.maxfm7
                              }
                            >
                              {
                                props.nutrition?.percentDailyValues
                                  ?.saturatedFat
                              }{' '}
                              %
                            </AVText>
                          </View>
                        )}
                      </View>
                    </React.Fragment>
                  )}

                  {checkValue(props.nutrition?.unsaturatedFat) && (
                    <React.Fragment>
                      <BlackLine height={1} />

                      <View
                        style={[
                          styles.fullInformationRow,
                          {
                            marginLeft: checkValue(props.nutrition?.totalFat)
                              ? Styles.Spacing.m4
                              : null,
                          },
                        ]}
                      >
                        <View style={styles.column}>
                          <View style={styles.row}>
                            <AVText
                              style={styles.amtPerServingValue}
                              maxFontSizeMultiplier={
                                Styles.FontSizeMultiplier.maxfm7
                              }
                            >
                              {Localized.Labels.unsaturated_fat}
                            </AVText>
                            <AVText
                              style={styles.amtPerServingValue}
                              maxFontSizeMultiplier={
                                Styles.FontSizeMultiplier.maxfm7
                              }
                            >
                              {props.nutrition?.unsaturatedFat} g
                            </AVText>
                          </View>
                        </View>
                      </View>
                    </React.Fragment>
                  )}

                  {checkValue(props.nutrition?.transFat) && (
                    <React.Fragment>
                      <BlackLine height={1} />

                      <View
                        style={[
                          styles.fullInformationRow,
                          {
                            marginLeft: checkValue(props.nutrition?.totalFat)
                              ? Styles.Spacing.m4
                              : null,
                          },
                        ]}
                      >
                        <View style={styles.column}>
                          <View style={styles.row}>
                            <AVText
                              style={styles.amtPerServingValue}
                              maxFontSizeMultiplier={
                                Styles.FontSizeMultiplier.maxfm7
                              }
                            >
                              {Localized.Labels.trans_fat}
                            </AVText>
                            <AVText
                              style={styles.amtPerServingValue}
                              maxFontSizeMultiplier={
                                Styles.FontSizeMultiplier.maxfm7
                              }
                            >
                              {props.nutrition?.transFat} g
                            </AVText>
                          </View>
                        </View>
                      </View>
                    </React.Fragment>
                  )}
                </View>

                {checkValue(props.nutrition?.cholesterol) && (
                  <React.Fragment>
                    <BlackLine height={1} />
                    <View style={styles.fullInformationRow}>
                      <View style={styles.column}>
                        <View style={styles.row}>
                          <AVText
                            style={styles.amtPerServingText}
                            maxFontSizeMultiplier={
                              Styles.FontSizeMultiplier.maxfm7
                            }
                          >
                            {Localized.Labels.cholesterol}
                          </AVText>
                          <AVText
                            style={styles.amtPerServingValue}
                            maxFontSizeMultiplier={
                              Styles.FontSizeMultiplier.maxfm7
                            }
                          >
                            {props.nutrition?.cholesterol} mg
                          </AVText>
                        </View>
                      </View>
                      {checkValue(
                        props.nutrition?.percentDailyValues?.cholesterol,
                      ) && (
                        <View style={styles.column}>
                          <AVText
                            style={styles.amtPerServingText}
                            maxFontSizeMultiplier={
                              Styles.FontSizeMultiplier.maxfm7
                            }
                          >
                            {props.nutrition?.percentDailyValues?.cholesterol} %
                          </AVText>
                        </View>
                      )}
                    </View>
                  </React.Fragment>
                )}

                {checkValue(props.nutrition?.sodium) && (
                  <React.Fragment>
                    <BlackLine height={1} />
                    <View style={styles.fullInformationRow}>
                      <View style={styles.column}>
                        <View style={styles.row}>
                          <AVText
                            style={styles.amtPerServingText}
                            maxFontSizeMultiplier={
                              Styles.FontSizeMultiplier.maxfm7
                            }
                          >
                            {Localized.Labels.sodium}
                          </AVText>
                          <AVText
                            style={styles.amtPerServingValue}
                            maxFontSizeMultiplier={
                              Styles.FontSizeMultiplier.maxfm7
                            }
                          >
                            {props.nutrition?.sodium} mg
                          </AVText>
                        </View>
                      </View>
                      {checkValue(
                        props.nutrition?.percentDailyValues?.sodium,
                      ) && (
                        <View style={styles.column}>
                          <AVText
                            style={styles.amtPerServingText}
                            maxFontSizeMultiplier={
                              Styles.FontSizeMultiplier.maxfm7
                            }
                          >
                            {props.nutrition?.percentDailyValues?.sodium} %
                          </AVText>
                        </View>
                      )}
                    </View>
                  </React.Fragment>
                )}

                {checkValue(props.nutrition?.totalCarbs) && (
                  <View style={styles.column}>
                    <BlackLine height={1} />
                    <View style={styles.fullInformationRow}>
                      <View style={styles.column}>
                        <View style={styles.row}>
                          <AVText
                            style={styles.amtPerServingText}
                            maxFontSizeMultiplier={
                              Styles.FontSizeMultiplier.maxfm7
                            }
                          >
                            {Localized.Labels.total_carbohydrate}
                          </AVText>
                          <AVText
                            style={styles.amtPerServingValue}
                            maxFontSizeMultiplier={
                              Styles.FontSizeMultiplier.maxfm7
                            }
                          >
                            {props.nutrition?.totalCarbs} g
                          </AVText>
                        </View>
                      </View>
                      {checkValue(
                        props.nutrition?.percentDailyValues?.totalCarbs,
                      ) && (
                        <View style={styles.column}>
                          <AVText
                            style={styles.amtPerServingText}
                            maxFontSizeMultiplier={
                              Styles.FontSizeMultiplier.maxfm7
                            }
                          >
                            {props.nutrition?.percentDailyValues?.totalCarbs} %
                          </AVText>
                        </View>
                      )}
                    </View>

                    {checkValue(props.nutrition?.dietaryFiber) && (
                      <React.Fragment>
                        <BlackLine height={1} />
                        <View
                          style={[
                            styles.fullInformationRow,
                            {
                              marginLeft: checkValue(
                                props.nutrition?.totalCarbs,
                              )
                                ? Styles.Spacing.m4
                                : null,
                            },
                          ]}
                        >
                          <View style={styles.column}>
                            <View style={styles.row}>
                              <AVText
                                style={styles.amtPerServingValue}
                                maxFontSizeMultiplier={
                                  Styles.FontSizeMultiplier.maxfm7
                                }
                              >
                                {Localized.Labels.dietary_fiber}
                              </AVText>
                              <AVText
                                style={styles.amtPerServingValue}
                                maxFontSizeMultiplier={
                                  Styles.FontSizeMultiplier.maxfm7
                                }
                              >
                                {props.nutrition?.dietaryFiber} g
                              </AVText>
                            </View>
                          </View>
                          {checkValue(
                            props.nutrition?.percentDailyValues?.dietaryFiber,
                          ) && (
                            <View style={styles.column}>
                              <AVText
                                style={styles.amtPerServingText}
                                maxFontSizeMultiplier={
                                  Styles.FontSizeMultiplier.maxfm7
                                }
                              >
                                {
                                  props.nutrition?.percentDailyValues
                                    ?.dietaryFiber
                                }{' '}
                                %
                              </AVText>
                            </View>
                          )}
                        </View>
                      </React.Fragment>
                    )}

                    {checkValue(props.nutrition?.sugars) && (
                      <React.Fragment>
                        <BlackLine height={1} />
                        <View
                          style={[
                            styles.fullInformationRow,
                            {
                              marginLeft: checkValue(
                                props.nutrition?.totalCarbs,
                              )
                                ? Styles.Spacing.m4
                                : null,
                            },
                          ]}
                        >
                          <View style={styles.column}>
                            <View style={styles.row}>
                              <AVText
                                style={styles.amtPerServingValue}
                                maxFontSizeMultiplier={
                                  Styles.FontSizeMultiplier.maxfm7
                                }
                              >
                                {Localized.Labels.sugars}
                              </AVText>
                              <AVText
                                style={styles.amtPerServingValue}
                                maxFontSizeMultiplier={
                                  Styles.FontSizeMultiplier.maxfm7
                                }
                              >
                                {props.nutrition?.sugars} g
                              </AVText>
                            </View>
                          </View>
                          {checkValue(
                            props.nutrition?.percentDailyValues?.sugars,
                          ) && (
                            <View style={styles.column}>
                              <AVText
                                style={styles.amtPerServingText}
                                maxFontSizeMultiplier={
                                  Styles.FontSizeMultiplier.maxfm7
                                }
                              >
                                {props.nutrition?.percentDailyValues?.sugars} %
                              </AVText>
                            </View>
                          )}
                        </View>
                      </React.Fragment>
                    )}
                  </View>
                )}

                {checkValue(props.nutrition?.proteing) && (
                  <React.Fragment>
                    <BlackLine height={1} />
                    <View style={styles.fullInformationRow}>
                      <View style={styles.column}>
                        <View style={styles.row}>
                          <AVText
                            style={styles.amtPerServingText}
                            maxFontSizeMultiplier={
                              Styles.FontSizeMultiplier.maxfm7
                            }
                          >
                            {Localized.Labels.protein}
                          </AVText>
                          <AVText
                            style={styles.amtPerServingValue}
                            maxFontSizeMultiplier={
                              Styles.FontSizeMultiplier.maxfm7
                            }
                          >
                            {props.nutrition?.proteing} g
                          </AVText>
                        </View>
                      </View>
                      {checkValue(
                        props.nutrition?.percentDailyValues?.protein,
                      ) && (
                        <View style={styles.column}>
                          <AVText
                            style={styles.amtPerServingText}
                            maxFontSizeMultiplier={
                              Styles.FontSizeMultiplier.maxfm7
                            }
                          >
                            {props.nutrition?.percentDailyValues?.protein} %
                          </AVText>
                        </View>
                      )}
                    </View>
                    <BlackLine height={10} />
                  </React.Fragment>
                )}

                {checkValue(props.nutrition?.vitaminA) && (
                  <React.Fragment>
                    <View style={styles.fullInformationRow}>
                      <View style={styles.column}>
                        <View style={styles.row}>
                          <AVText
                            style={styles.amtPerServingValue}
                            maxFontSizeMultiplier={
                              Styles.FontSizeMultiplier.maxfm7
                            }
                          >
                            {Localized.Labels.vitaminA}
                          </AVText>
                          <AVText
                            style={styles.amtPerServingValue}
                            maxFontSizeMultiplier={
                              Styles.FontSizeMultiplier.maxfm7
                            }
                          >
                            {props.nutrition?.vitaminA} mcg
                          </AVText>
                        </View>
                      </View>
                      {checkValue(
                        props.nutrition?.percentDailyValues?.vitaminA,
                      ) && (
                        <View style={styles.column}>
                          <AVText
                            style={styles.amtPerServingText}
                            maxFontSizeMultiplier={
                              Styles.FontSizeMultiplier.maxfm7
                            }
                          >
                            {props.nutrition?.percentDailyValues?.vitaminA} %
                          </AVText>
                        </View>
                      )}
                    </View>
                  </React.Fragment>
                )}

                {checkValue(props.nutrition?.vitaminC) && (
                  <React.Fragment>
                    <BlackLine height={1} />
                    <View style={styles.fullInformationRow}>
                      <View style={styles.column}>
                        <View style={styles.row}>
                          <AVText
                            style={styles.amtPerServingValue}
                            maxFontSizeMultiplier={
                              Styles.FontSizeMultiplier.maxfm7
                            }
                          >
                            {Localized.Labels.vitaminC}
                          </AVText>
                          <AVText
                            style={styles.amtPerServingValue}
                            maxFontSizeMultiplier={
                              Styles.FontSizeMultiplier.maxfm7
                            }
                          >
                            {props.nutrition?.vitaminC} mg
                          </AVText>
                        </View>
                      </View>
                      {checkValue(
                        props.nutrition?.percentDailyValues?.vitaminC,
                      ) && (
                        <View style={styles.column}>
                          <AVText
                            style={styles.amtPerServingText}
                            maxFontSizeMultiplier={
                              Styles.FontSizeMultiplier.maxfm7
                            }
                          >
                            {props.nutrition?.percentDailyValues?.vitaminC} %
                          </AVText>
                        </View>
                      )}
                    </View>
                  </React.Fragment>
                )}

                {checkValue(props.nutrition?.calcium) && (
                  <React.Fragment>
                    <BlackLine height={1} />
                    <View style={styles.fullInformationRow}>
                      <View style={styles.column}>
                        <View style={styles.row}>
                          <AVText
                            style={styles.amtPerServingValue}
                            maxFontSizeMultiplier={
                              Styles.FontSizeMultiplier.maxfm7
                            }
                          >
                            {Localized.Labels.calcium}
                          </AVText>
                          <AVText
                            style={styles.amtPerServingValue}
                            maxFontSizeMultiplier={
                              Styles.FontSizeMultiplier.maxfm7
                            }
                          >
                            {props.nutrition?.calcium} mg
                          </AVText>
                        </View>
                      </View>
                      {checkValue(
                        props.nutrition?.percentDailyValues?.calcium,
                      ) && (
                        <View style={styles.column}>
                          <AVText
                            style={styles.amtPerServingText}
                            maxFontSizeMultiplier={
                              Styles.FontSizeMultiplier.maxfm7
                            }
                          >
                            {props.nutrition?.percentDailyValues?.calcium} %
                          </AVText>
                        </View>
                      )}
                    </View>
                  </React.Fragment>
                )}

                {checkValue(props.nutrition?.potassium) && (
                  <React.Fragment>
                    <BlackLine height={1} />
                    <View style={styles.fullInformationRow}>
                      <View style={styles.column}>
                        <View style={styles.row}>
                          <AVText
                            style={styles.amtPerServingValue}
                            maxFontSizeMultiplier={
                              Styles.FontSizeMultiplier.maxfm7
                            }
                          >
                            {Localized.Labels.potassium}
                          </AVText>
                          <AVText
                            style={styles.amtPerServingValue}
                            maxFontSizeMultiplier={
                              Styles.FontSizeMultiplier.maxfm7
                            }
                          >
                            {props.nutrition?.potassium} mg
                          </AVText>
                        </View>
                      </View>
                      {checkValue(
                        props.nutrition?.percentDailyValues?.potassium,
                      ) && (
                        <View style={styles.column}>
                          <AVText
                            style={styles.amtPerServingText}
                            maxFontSizeMultiplier={
                              Styles.FontSizeMultiplier.maxfm7
                            }
                          >
                            {props.nutrition?.percentDailyValues?.potassium} %
                          </AVText>
                        </View>
                      )}
                    </View>
                  </React.Fragment>
                )}

                {checkValue(props.nutrition?.iron) && (
                  <React.Fragment>
                    <BlackLine height={1} />
                    <View style={styles.fullInformationRow}>
                      <View style={styles.column}>
                        <View style={styles.row}>
                          <AVText
                            style={styles.amtPerServingValue}
                            maxFontSizeMultiplier={
                              Styles.FontSizeMultiplier.maxfm7
                            }
                          >
                            {Localized.Labels.iron}
                          </AVText>
                          <AVText
                            style={styles.amtPerServingValue}
                            maxFontSizeMultiplier={
                              Styles.FontSizeMultiplier.maxfm7
                            }
                          >
                            {props.nutrition?.iron} mg
                          </AVText>
                        </View>
                      </View>
                      {checkValue(
                        props.nutrition?.percentDailyValues?.iron,
                      ) && (
                        <View style={styles.column}>
                          <AVText
                            style={styles.amtPerServingText}
                            maxFontSizeMultiplier={
                              Styles.FontSizeMultiplier.maxfm7
                            }
                          >
                            {props.nutrition?.percentDailyValues?.iron} %
                          </AVText>
                        </View>
                      )}
                    </View>
                  </React.Fragment>
                )}

                {checkValue(props.nutrition?.caffeine) && (
                  <React.Fragment>
                    <BlackLine height={1} />
                    <View style={styles.fullInformationRow}>
                      <View style={styles.column}>
                        <View style={styles.row}>
                          <AVText
                            style={styles.amtPerServingValue}
                            maxFontSizeMultiplier={
                              Styles.FontSizeMultiplier.maxfm7
                            }
                          >
                            {Localized.Labels.caffeine}
                          </AVText>
                          <AVText
                            style={styles.amtPerServingValue}
                            maxFontSizeMultiplier={
                              Styles.FontSizeMultiplier.maxfm7
                            }
                          >
                            {props.nutrition?.caffeine} mg
                          </AVText>
                        </View>
                      </View>
                      {checkValue(
                        props.nutrition?.percentDailyValues?.caffeine,
                      ) && (
                        <View style={styles.column}>
                          <AVText
                            style={styles.amtPerServingText}
                            maxFontSizeMultiplier={
                              Styles.FontSizeMultiplier.maxfm7
                            }
                          >
                            {props.nutrition?.percentDailyValues?.caffeine} %
                          </AVText>
                        </View>
                      )}
                    </View>
                  </React.Fragment>
                )}
              </React.Fragment>
            )}

            <BlackLine height={1} />
            <View style={styles.fullInformationRow}>
              <AVText
                style={styles.bottomText}
                maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm7}
              >
                * {Localized.Labels.percent_daily_values_explaination}
              </AVText>
            </View>
          </View>
        </SafeAreaView>
      </ScrollView>
    </BackSubheader>
  );
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: Styles.white,
    borderColor: Styles.darkColor,
    borderWidth: 1,
    marginHorizontal: Styles.Spacing.m2,
    marginVertical: Styles.Spacing.m3,
  },
  title: {
    fontSize: Styles.Fonts.f3,
    fontWeight: '700',
    color: Styles.darkColor,
    marginBottom: Styles.Spacing.m2,
  },
  servingContainer: {
    flexDirection: 'column',
    marginBottom: Styles.Spacing.m2,
  },
  blackLine: {
    backgroundColor: Styles.darkColor,
    paddingHorizontal: 20,
  },
  calorieContainer: {
    flexDirection: 'column',
    marginBottom: Styles.Spacing.m2,
    marginTop: Styles.Spacing.m2,
  },
  smallText: {
    fontSize: 10,
    marginBottom: 7.5,
  },
  calorieText: {
    paddingTop: Styles.Spacing.m1,
    fontWeight: '700',
    fontSize: 24,
  },
  amtPerServingText: {
    paddingTop: 5,
    fontWeight: '700',
  },
  amtPerServingValue: {
    paddingTop: Styles.Spacing.m1,
    marginHorizontal: Styles.Spacing.m1,
  },
  bottomText: {
    marginTop: Styles.Spacing.m2,
    flexWrap: 'wrap',
    fontSize: 10,
  },
  fullInformationRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: Styles.Spacing.m1,
  },
  row: {
    flexDirection: 'row',
    paddingVertical: 2.5,
  },
  column: {
    flexDirection: 'column',
  },
});

export default withForwardedNavigationParams()(ViewNutrition);
